var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.cssClasses},[_c('label',[_c('span',[_vm._v(_vm._s(_vm.offText))]),_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled,"readonly":_vm.readonly},domProps:{"checked":_vm.value},on:{"change":_vm.onChange}}),_c('span',{staticClass:"lever"}),_c('span',[_vm._v(_vm._s(_vm.onText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }